export enum SourceAccessibleForEnum {

    TeachersAndStudents = 1,

    Teachers = 2,

}
